import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '@features/showroom/sections/Map/Components/LocationSelect/LocationSelect.styles';
import { ILocationItems } from '@features/showroom/typescript';
import Heading from '@components/Heading/Heading';
type PropsType = {
  location: ILocationItems;
  setCoordinate: Dispatch<SetStateAction<Array<ILocationItems>>>;
};
const LocationSelect = ({
  location,
  setCoordinate
}: PropsType) => {
  const {
    name,
    address,
    city,
    postcode,
    phone
  } = location;
  const handleCoordinateChange = () => {
    setCoordinate([location]);
  };
  const {
    t
  } = useTranslation('common');
  return <div sx={styles.locationItem} role="button" tabIndex={0} onClick={handleCoordinateChange} onKeyDown={handleCoordinateChange}>
      <Heading h={5} headingType={5} bold mobile pb={1}>
        {name}
      </Heading>
      <p>{address}</p>
      <p className="small">
        {phone && `${t('phone')} ${phone} / `} {city} {postcode}
      </p>
    </div>;
};
export default LocationSelect;